import { IUpdateConfigurationOverrideRequest } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class ConfigurationOverrideService {
  private static baseUrl: string = '/api/configurationoverride';

  static tags = {
    updateConfigurationOverride: 'updateConfigurationOverride',
  };

  static updateConfigurationOverride(
    data: IUpdateConfigurationOverrideRequest,
  ) {
    return trackPromise(
      new Promise<void>((resolve, reject) => {
        http(`${this.baseUrl}/updateconfigurationoverride`)
          .post(data)
          .then(() => resolve())
          .catch((err) => reject(err));
      }),
      this.tags.updateConfigurationOverride,
    );
  }
}
